module.exports = __webpack_public_path__ + "img/20210906-1630911057982308.48dac47f.jpg";